export { HowWorks } from './how-works'
export * from './how-works.model'
